module.exports = __webpack_public_path__ + "media/src/images/new_window_on-bb9264f5b46d148de81667cb6f2f7e00.png";